import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-question-group',
    templateUrl: './question-group.component.html',
    styleUrls: ['./question-group.component.scss'],
    standalone: false
})
export class QuestionGroupComponent {
  @Input() legend: any;
  // Optional extra classes applied to the <legend>, so a template can keep the
  // styling its former question <p> had (e.g. 'gub-italic').
  @Input() legendClass: any;
  // Optional id for the <legend>, so answer controls can reference the question
  // text via aria-labelledby (screen readers then read the question when the
  // control is hovered/focused, not just when the group is entered).
  @Input() legendId: any;
}
